export * from './iconFontAwesomeMarketingFish';
export * from './iconFontAwesomeMarketingAnchor';
export * from './iconFontAwesomeMarketingWater';
export * from './iconFontAwesomeMarketingShip';
export * from './iconFontAwesomeMarketingOtter';
export * from './iconFontAwesomeMarketingShrimp';
export * from './iconFontAwesomeMarketingSailboat';
export * from './iconFontAwesomeMarketingPersonSwimming';
export * from './iconFontAwesomeMarketingFishFins';
export * from './iconFontAwesomeMarketingFerry';
export * from './iconFontAwesomeMarketingAnchorLock';
export * from './iconFontAwesomeMarketingAnchorCircleXmark';
export * from './iconFontAwesomeMarketingAnchorCircleExclamation';
export * from './iconFontAwesomeMarketingAnchorCircleCheck';
